<template>
    <div class="col-md-9">
        <h1 class="pages__title">{{ newsId ? `edit news` : 'add news' }} </h1>
        <div class="pages__box">
            <div class="form">
                <ValidationObserver ref="form">

                    <ValidationProvider
                        class="form-group"
                        name="Title"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Title</label>
                        <input type="text" class="form-control pl-4" v-model="newsInfo.title">
                        <FormError :error="errors[0]" name="Title"/>
                    </ValidationProvider>

                    <ValidationProvider
                        class="form-group"
                        name="Route"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Route</label>
                        <input type="text" class="form-control pl-4" v-model="newsInfo.slug">
                        <FormError :error="errors[0]" name="Route"/>
                    </ValidationProvider>

                    <ImageGallery
                        :uploadHandler="uploadImagesForNews"
                        :uploaded-images="newsInfo.slider_images"
                        @upload-gallery="getPhotosIds"
                    />

                    <ValidationProvider
                        class="form-group"
                        name="Title"
                        v-slot="{ errors }"
                        rules="min:2"
                    >
                        <label class="form-label">Description*</label>

                        <TinyMce
                            :props-value="newsInfo.content"
                            :uploadHandler="uploadImagesForNews"
                            @update-content="updateContent"
                        />

                        <FormError :error="errors[0]" name="Route"/>
                    </ValidationProvider>

                    <BaseButtons
                        :on-cancel="backToPreviousPage"
                        :on-save="validate"
                    />
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import AdminPanelService from "../../../services/AdminPanelService";
import BaseButtons from "../../Common/BaseButtons.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import FormError from "../../Common/FormError.vue";
import ImageGallery from "../../Common/ImageGallery.vue";
import TinyMce from "../../Common/ContentFields/TinyMce.vue";


export default defineComponent({
    name: "NewsEditor",
    components: {TinyMce, ImageGallery, FormError, BaseButtons},
    mixins: [ModalHandler],
    props: {
        newsId: Number
    },
    data() {
        return {
            newsInfo: {
                id: null,
                title: null,
                slug: null,
                images: [],
                content: '',
            },
        }
    },
    methods: {
        updateContent(newContent) {
            this.newsInfo.content = newContent
        },
        getPhotosIds(ids) {
            this.newsInfo.images = ids
        },
        async uploadImagesForNews(formData) {
            return await AdminPanelService.uploadImagesForNews(formData)
        },
        async validate() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            await this.saveNewsInfo()
        },
        async saveNewsInfo() {
            this.$showLoadingMessage()
            const uploadMethod = this.newsId
                ? AdminPanelService.updateNewsInfo(this.newsId, this.newsInfo)
                : AdminPanelService.createNews(this.newsInfo);

            try {
                await uploadMethod
                this.$showSuccessMessage("The News  was saved");
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The News was not saved, please try again')
            }
        },
        async getNewsInfo(id) {
            try {
                const {data: response} = await AdminPanelService.fetchNewsInfo(id)
                this.newsInfo = response
            } catch (e) {
                console.error(e)
            }
        }
    },
    mounted() {
        if (this.newsId) {
            this.getNewsInfo(this.newsId)
        }
    },

})
</script>


<style scoped>

</style>
